'use strict';

angular.module('referrals').directive('msCustomField', [function () {
  return {
    template: '<div ng-include="template"/>',
    scope: {
      'field': '=msCustomField'
    },
    link: function link(scope) {
      if (scope.field.inputType === 'CHECK_BOX') {
        scope.template = 'referrals/templates/customFieldCheckbox.html';
      } else if (scope.field.inputType === 'TEXT') {
        scope.template = 'referrals/templates/customFieldText.html';
      } else if (scope.field.inputType === 'DROP_DOWN') {
        scope.template = 'referrals/templates/customFieldDropdown.html';
      }
    }
  };
}]);